import React from 'react';
import { Skeleton } from '@mui/material';

import './search-result-skeleton-style.scss';

import { SKELETON_COLOR } from '@src/utils/constants';

interface SearchResultSkeletonProps {
  isMobile?: boolean;
  type?: 'product' | 'category' | 'brand' | 'ui-component';
}

const SearchResultSkeleton = ({ isMobile, type }: SearchResultSkeletonProps) => {
  return (
    <div className={`search-result-skeleton-wrapper ${isMobile ? 'mobile' : ''}`}>
      <Skeleton
        variant="rectangular"
        width={60}
        height={20}
        style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }}
      />

      {type === 'ui-component' ? (
        <div className="search-result-skeleton-image-container">
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={80}
              height={80}
              style={{ backgroundColor: SKELETON_COLOR, borderRadius: 12 }}
            />
          ))}
        </div>
      ) : (
        <Skeleton
          variant="rectangular"
          width="100%"
          height={60}
          style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }}
        />
      )}
    </div>
  );
};

export default SearchResultSkeleton;
